import { EntityStateEnum } from "@app/shared/common/enums";
import { QuestionListItem } from "./question-list-item";
import { QuestionCollectionQuestionRelations } from "./question-collection-question-relation-item";

export class QuestionCollectionFormItem {
    id: string;
    title: string;
    description: string;
    questionCollectionCategory: string;
    filteredQuestionCollectionCategory: string;
    languageId: string;
    questionCollectionLanguageId: string;
    duration: number;
    responsible: string;
    stepDurationType: number;
    showToApplicant: boolean;
    organizationID: string;
    subCategory: number;
    isTemprature: boolean;
    xmin: number;
    entityState: EntityStateEnum;
    questionCollectionQuestionRelations: QuestionCollectionQuestionRelations[] = [];
    level?: number;
    schedulingEventID?: string;
    // Genel Bilişsel Yetenek (shuffle cognitive) step'i için seviye bazlı soru sayıları.
    cognitiveEasyCount?: number;
    cognitiveMediumCount?: number;
    cognitiveHardCount?: number;
    // Case Study kategorisi: vaka materyali blokları (JSON string, bkz. models/case-brief.ts).
    caseBrief?: string;
}

